import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_USER_REQUEST = 'appUser/FETCH_USER_REQUEST'
const FETCH_USER_SUCCESS = 'appUser/FETCH_USER_SUCCESS'
const FETCH_USER_FAILURE = 'appUser/FETCH_USER_FAILURE'

const UPDATE_USER_REQUEST = 'appUser/UPDATE_USER_REQUEST'
const UPDATE_USER_SUCCESS = 'appUser/UPDATE_USER_SUCCESS'
const UPDATE_USER_FAILURE = 'appUser/UPDATE_USER_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  userList: [],
}

// Default Reducer
const appUser = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userList: action.payload
      }
    case FETCH_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_USER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}

export default appUser

// Action Creators
export const getAllAppUsers = (options) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_USER_REQUEST
      })

      const response = await API.get(EndPoints.APPUSER + `/search`, {
        params: options
      })
      dispatch({
        type: FETCH_USER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_USER_FAILURE
      })
    }
  }
}

export const updateUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_USER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.LOGIN+ `/user/updateUserBrand`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_USER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_USER_FAILURE
      })
    }
  }
}










// WEBPACK FOOTER //
// ./src/modules/appUser.js